module Meevo.Components.Controls {
    "use strict";


    angular.module('meevo.components.controls').directive("meevoMover", ["$compile", function ($compile: angular.ICompileService) {
        return {
            restrict: 'E',
            transclude: {
                'filterButton': '?filterButton'
            },
            require: '^form',
            templateUrl: "app/components/controls/moverTemplate.html",
            scope: {
                template: "@",
                items: "=",
                contentKey: "@",
                readonly: "=ngReadonly",
                required: "=ngRequired",
                allowOrdering: "=",
                name: "@",
                itemTemplateUrl: "@",
                typeAheadCriteria: "=?",
                typeAheadPreProcessData: "=?",
                changed: "=?",
                maxItems: "@",
                asLocationId: "=?",
                businessTypeId: "=?",
                customDelete: "=",
                tabIndex: "=?",
                context: "=?",
                preDelete: "="
            },
            link: function (scope: any, element, attr, form: any) {
                scope.maxItems = !scope.maxItems ? 0 : scope.maxItems;
                var template;
                scope.form = form;

                scope.$watch("items", function () {
                    validate();
                }, true);

                scope.$watch("required", function () {
                    validate();
                });

                function validate() {
                    if (form[scope.name]) {
                        let isInvalid = scope.required && Model.Guard.isSomething(scope.items) && scope.items.length == 0;
                        form[scope.name].$setValidity("required", !isInvalid);
                    }
                }

                scope.isValid = function () {
                    return form[scope.name] && form[scope.name].$error.required;
                }

                configure();

                function configure() {
                    let defaultTemplate = "{{shortcut}}: {{displayName}}";
                    if (scope.template == undefined) {
                        throw "Template not specificied";
                    }
                    switch (scope.template.toLowerCase()) {
                        case "employee":
                            template = Handlebars.compile("{{#if code}}{{code}}: {{/if}}{{lastName}}, {{firstName}}");
                            break;
                        case "employeeoverrides":
                            template = Handlebars.compile("{{displayName}}");
                            break;
                        case "service":
                            template = Handlebars.compile(defaultTemplate);
                            break;
                        case "resource":
                            template = Handlebars.compile(defaultTemplate);
                            break;
                        case "productvariant":
                            template = Handlebars.compile("{{sku}} : {{productName}}{{#if displayName}}-{{displayName}}{{/if}} : {{barCode}}");
                            break;
                        case "securityrole":
                            template = Handlebars.compile("{{displayName}}");
                            break;
                        case "equipment":
                            template = Handlebars.compile("{{displayName}}");
                            break;
                        case "servicecategory":
                            template = Handlebars.compile("{{displayName}}");
                            break;
                        case "clientclienttype":
                            template = Handlebars.compile("{{displayName}}");
                            break;
                        case "packagetype":
                            template = Handlebars.compile("{{displayName}}");
                            break;
                        case "membership":
                            template = Handlebars.compile("{{displayName}}");
                            break;
                        case "giftcardtype":
                            template = Handlebars.compile("{{displayName}}");
                            break;
                        case "fees":
                            template = Handlebars.compile("{{displayName}}");
                            break;
                        case "clientservice":
                            // uses itemTemplateUrl
                            break;
                        default:
                            throw "Mover configuration exception: template could not be found";
                    }
                }

                scope.preProcess = function (response, request): void {
                    if (Meevo.Model.Guard.isSomething(scope.typeAheadPreProcessData)) {
                        scope.typeAheadPreProcessData(response, request)
                    }
                }

                scope.deleteItem = function (index) {
                    let canDelete = true;
                    if (_.isFunction(scope.preDelete)) {
                        canDelete = scope.preDelete(scope.context, scope.items, index);
                    }
                    if (canDelete) {
                        scope.items.splice(index, 1);
                    }
                }

                scope.modelChanged = function () {
                    if (scope.selected && !_.findWhere(scope.items, { id: scope.selected.id })) {
                        switch (scope.template.toLowerCase()) {
                            case "clientservice":
                                scope.selected.frequencyOfVisit = 1;
                                break;
                        }
                        if (angular.isFunction(scope.changed)) {
                            scope.changed(scope.selected, scope.typeAheadCriteria)
                        } else {
                            scope.items.push(scope.selected);
                        }

                    }
                    scope.selected = undefined;
                }
                scope.getContents = function (item) {
                    return template(item);
                }

                scope.up = function (index) {

                    if (index === 0)
                        return;

                    let copy = [];
                    for (let i = 0; i < index - 1; i++) {
                        copy.push(scope.items[i]);
                    }
                    copy.push(scope.items[index]);
                    copy.push(scope.items[index - 1]);
                    for (let i = index + 1; i < scope.items.length; i++) {
                        copy.push(scope.items[i]);
                    }
                    scope.items = copy;
                }

                scope.down = function (index) {
                    if (index === scope.items.length - 1) {
                        return;
                    }

                    let copy = [];
                    for (let i = 0; i < index; i++) {
                        copy.push(scope.items[i]);
                    }
                    copy.push(scope.items[index + 1]);
                    copy.push(scope.items[index]);

                    for (let i = index + 2; i < scope.items.length; i++) {
                        copy.push(scope.items[i]);
                    }
                    scope.items = copy;
                }
            }
        }
    }]);
}